import styles from './TextAreaWithAutocomplete.module.scss';
import styles2 from 'pages/AddAccount/AddAccount.module.scss';
import { useEffect, useState } from 'react';

const TABLEOPTIONS = [
  'Desplazamiento',
  'Kilometraje',
  'Servicio Urgente',
  'Servicio Nocturno',
  'Servicio en dia Festivo',
  'Mano de Obra',
  'Materiales',
];

export const TextAreaWithAutocomplete = ({ name, tableData, setTableData, i }) => {
  const [tableOptions, setTableOptions] = useState(TABLEOPTIONS);
  const [isDropdownShown, setIsDropdownShown] = useState(false);

  useEffect(
    () => setTableOptions(TABLEOPTIONS.filter((item) => !tableData.find(({ name }) => name === item))),
    [tableData],
  );

  return (
    <div className={styles.container}>
      <textarea
        className={styles2.tableInput}
        type='text'
        value={name}
        rows={1}
        onChange={(e) => {
          setTableData((prev) => prev.map((item, index) => (i === index ? { ...item, name: e.target.value } : item)));
        }}
        onFocus={() => setIsDropdownShown(true)}
        onBlur={() => {
          setTimeout(() => setIsDropdownShown(false), 200);
        }}
      />
      {isDropdownShown && tableOptions.length > 0 && (
        <div className={styles.dropdown}>
          {tableOptions
            .filter((item) => item.toLocaleUpperCase().includes(name.toLocaleUpperCase()))
            .map((option) => (
              <div
                key={option}
                onClick={() => {
                  setTableData((prev) => prev.map((item, index) => (i === index ? { ...item, name: option } : item)));
                }}
              >
                {option}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};
